"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _reduxForm = require("redux-form");
var _reactI18next = require("react-i18next");
var _core = require("@material-ui/core");
var _reactRedux = require("react-redux");
var _reactStripeJs = require("@stripe/react-stripe-js");
var _Lock = _interopRequireDefault(require("@material-ui/icons/Lock"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _lodash = _interopRequireDefault(require("lodash"));
var _Input = _interopRequireDefault(require("./Input"));
var _2 = require("..");
var _pittaModules = require("@thingsw/pitta-modules");
var _excluded = ["touched", "invalid", "error"],
  _excluded2 = ["label", "input", "helperText", "meta", "t"],
  _excluded3 = ["input", "label", "meta", "helperText", "t", "children", "items"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var renderEmailField = function renderEmailField(_ref) {
  var label = _ref.label,
    input = _ref.input,
    helperText = _ref.helperText,
    _ref$meta = _ref.meta,
    touched = _ref$meta.touched,
    invalid = _ref$meta.invalid,
    error = _ref$meta.error,
    restMeta = _objectWithoutProperties(_ref$meta, _excluded),
    t = _ref.t,
    custom = _objectWithoutProperties(_ref, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_Input.default, _extends({
    label: label,
    error: touched && invalid,
    helperText: touched && t(error) || helperText
  }, input, custom));
};
var renderSelectField = function renderSelectField(_ref2) {
  var _input$value$key;
  var input = _ref2.input,
    label = _ref2.label,
    _ref2$meta = _ref2.meta,
    touched = _ref2$meta.touched,
    error = _ref2$meta.error,
    invalid = _ref2$meta.invalid,
    helperText = _ref2.helperText,
    t = _ref2.t,
    children = _ref2.children,
    items = _ref2.items,
    custom = _objectWithoutProperties(_ref2, _excluded3);
  return /*#__PURE__*/_react.default.createElement(_2.Selector, {
    menuScrollTime: true,
    keyValue: (_input$value$key = input.value.key) !== null && _input$value$key !== void 0 ? _input$value$key : "country",
    helperText: touched && t(error) || helperText,
    onChange: input.onChange,
    error: touched && invalid,
    items: items
  });
};
var CheckboxFormControlLabel = (0, _styles.withStyles)({
  root: {
    marginLeft: -6,
    marginRight: 0,
    display: "flex",
    alignItems: "flex-start"
  },
  label: {
    padding: "3px 0 0 2px"
  }
})(_core.FormControlLabel);
var renderCheckField = function renderCheckField(_ref3) {
  var label = _ref3.label,
    input = _ref3.input,
    referralChecked = _ref3.referralChecked,
    _ref3$meta = _ref3.meta,
    touched = _ref3$meta.touched,
    invalid = _ref3$meta.invalid,
    error = _ref3$meta.error,
    t = _ref3.t;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(CheckboxFormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_2.CheckBox, {
      name: input.name,
      color: "primary",
      value: input.value,
      checked: referralChecked,
      onChange: input.onChange
    }),
    label: label
  }), touched && error && /*#__PURE__*/_react.default.createElement(_core.FormHelperText, {
    style: {
      color: _pittaModules.LightColors.secondary["11"],
      marginLeft: 28
    }
  }, touched && t(error)));
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    marginB1: {
      marginBottom: theme.spacing(1)
    },
    marginB12: {
      marginBottom: theme.spacing(1.5)
    },
    marginB2: {
      marginBottom: theme.spacing(2)
    },
    marginB3: {
      marginBottom: theme.spacing(3)
    },
    marginT3: {
      marginTop: theme.spacing(3)
    },
    paddingT1: {
      paddingTop: theme.spacing(1)
    },
    paddingT2: {
      paddingTop: theme.spacing(2)
    },
    paddingB1: {
      paddingBottom: theme.spacing(1)
    },
    paddingB2: {
      paddingBottom: theme.spacing(2)
    },
    formControlLabel: {
      padding: "3px 0 0 2px"
    },
    cardNumDiv: {
      border: "1px solid ".concat(_pittaModules.LightColors.primary["4"]),
      padding: "9px 13px 9px 16px",
      borderRadius: 4
    },
    cardNumDivError: {
      borderColor: _pittaModules.LightColors.secondary["11"]
    },
    addressDetailDiv: _defineProperty({}, theme.breakpoints.up(_pittaModules.Webviewer.mobile), {
      display: "flex",
      justifyContent: "space-between"
    }),
    regionDiv: _defineProperty({
      marginBottom: theme.spacing(3)
    }, theme.breakpoints.up(_pittaModules.Webviewer.mobile), {
      marginRight: theme.spacing(2),
      marginBottom: 0,
      width: function width(props) {
        return props.mode === "sim" ? "48.5%" : "auto";
      }
    }),
    zipDiv: _defineProperty({}, theme.breakpoints.up(_pittaModules.Webviewer.mobile), {
      width: function width(props) {
        return props.mode === "sim" ? "48%" : "auto";
      }
    }),
    referralDiv: {
      marginBottom: theme.spacing(1) + 1
    },
    input50per: _defineProperty({}, theme.breakpoints.up(_pittaModules.Webviewer.mobile), {
      maxWidth: 211
    }),
    closeInput: {
      marginTop: 21
    },
    helperTextDiv: {
      margin: "3px 16px 0px"
    }
  };
});
var BillInfo = function BillInfo(props) {
  var _ref5, _ref7;
  var loading = props.loading,
    mode = props.mode,
    onUpdateCardElement = props.onUpdateCardElement,
    handleSubmit = props.handleSubmit,
    onCardError = props.onCardError,
    cameraCnt = props.cameraCnt,
    freetrial = props.freetrial,
    state = props.state,
    btnClassName = props.btnClassName,
    regionClassName = props.regionClassName,
    zipClassName = props.zipClassName;
  var classes = useStyles(props);
  // const theme = useTheme();
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  // const mobile = useMediaQuery(theme.breakpoints.down(Webviewer.mobile));
  var _useState = (0, _react.useState)(cameraCnt ? cameraCnt : 1),
    _useState2 = _slicedToArray(_useState, 2),
    camCnt = _useState2[0],
    setCamCnt = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    /*disabledChange*/setDisabledChange = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    referralChecked = _useState6[0],
    setReferralChecked = _useState6[1];
  // const [cardError, setCardError] = useState<string>();

  var stripe = (0, _reactStripeJs.useStripe)();
  var elements = (0, _reactStripeJs.useElements)();
  var _ref4 = (_ref5 = (0, _reduxForm.getFormValues)("BillInfoForm")(state)) !== null && _ref5 !== void 0 ? _ref5 : {
      cameraNum: "1"
    },
    cameraNum = _ref4.cameraNum;
  var _ref6 = (_ref7 = (0, _reduxForm.getFormValues)("BillInfoForm")(state)) !== null && _ref7 !== void 0 ? _ref7 : {
      referralCode: ""
    },
    referralCode = _ref6.referralCode;
  (0, _react.useEffect)(function () {
    dispatch((0, _reduxForm.change)("BillInfoForm", "cameraNum", cameraCnt ? cameraCnt : 1));
  }, [cameraCnt, dispatch]);
  var handleCardError = (0, _react.useCallback)(function (event) {
    console.log("change", event);
    if (event.error) {
      // dispatch(setSubmitFailed("BillInfoForm", "cardNumber"));
      onCardError === null || onCardError === void 0 ? void 0 : onCardError(event.error.code);
      // switch (event.error.code) {
      //   case "invalid_expiry_year_past":
      //     throw new SubmissionError({
      //       cardNumber: "invalid_expiry_year_past",
      //     });
      // }
    }
  }, [onCardError]);
  (0, _react.useEffect)(function () {
    if (!stripe || !elements) {
      return;
    }
    var cardElement = elements.getElement(_reactStripeJs.CardElement);
    if (cardElement) {
      onUpdateCardElement(stripe, cardElement, cameraNum, referralCode);
      cardElement.on("change", handleCardError);
    }
    return function () {
      if (cardElement) {
        cardElement.off("change", handleCardError);
      }
    };
  }, [stripe, elements, cameraNum, referralCode, onUpdateCardElement, handleCardError]);
  var handleEnterkey = function handleEnterkey(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      dispatch((0, _reduxForm.submit)("BillInfoForm"));
    }
  };
  var handleReferralInput = (0, _react.useCallback)(function (e) {
    if (e.target.checked) {
      setReferralChecked(true);
    } else if (!e.target.checked) {
      setReferralChecked(false);
    }
  }, []);
  var handleCamNumInput = (0, _react.useCallback)(function (e) {
    var cnt = 1;
    if (e.target.value !== "") {
      var value = Number.parseInt(e.target.value);
      cnt = Math.min(Math.max(1, value), _pittaModules.MAX_CAM_COUNT);
    }
    setCamCnt(cnt);
    dispatch((0, _reduxForm.change)("BillInfoForm", "cameraNum", cnt));
    setDisabledChange(false);
  }, [dispatch]);
  var cardElementMarkup = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react.default.createElement(_reactStripeJs.CardElement, {
      options: {
        style: {
          base: {
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: 400,
            fontFamily: "Roboto",
            "::placeholder": {
              fontSize: "16px",
              lineHeight: "24px",
              fontWeight: 400,
              fontFamily: "Roboto"
            }
          }
        }
      }
    });
  }, []);
  var renderCardField = (0, _react.useCallback)(function (_ref8) {
    var _ref8$meta = _ref8.meta,
      touched = _ref8$meta.touched,
      invalid = _ref8$meta.invalid,
      error = _ref8$meta.error;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx2.default)(classes.cardNumDiv, _defineProperty({}, classes.cardNumDivError, error))
    }, cardElementMarkup), error && /*#__PURE__*/_react.default.createElement(_2.Typography, {
      category: "Default",
      variant: "Caption",
      htmlColor: _pittaModules.LightColors.secondary["11"],
      className: classes.helperTextDiv
    }, t(error)));
  }, [cardElementMarkup, classes.cardNumDiv, classes.cardNumDivError, classes.helperTextDiv, t]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit,
    onKeyDown: handleEnterkey
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.marginB3
  }, /*#__PURE__*/_react.default.createElement(_reduxForm.Field, {
    name: "name",
    label: t("Cardholder name"),
    component: renderEmailField,
    t: t,
    autoFocus: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(classes.marginB3)
  }, /*#__PURE__*/_react.default.createElement(_reduxForm.Field, {
    name: "cardNumber",
    component: renderCardField
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.marginB3
  }, /*#__PURE__*/_react.default.createElement(_reduxForm.Field, {
    name: "address_country",
    label: t("Country"),
    component: renderSelectField,
    items: _lodash.default.map(_pittaModules.Countries, function (val, key) {
      return {
        key: key,
        value: val
      };
    }),
    t: t
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.marginB3
  }, /*#__PURE__*/_react.default.createElement(_reduxForm.Field, {
    name: "address_line1",
    label: t("Address"),
    component: renderEmailField,
    t: t
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.marginB3
  }, /*#__PURE__*/_react.default.createElement(_reduxForm.Field, {
    name: "address_city",
    label: t("City"),
    component: renderEmailField,
    t: t
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(classes.marginB3, regionClassName)
  }, /*#__PURE__*/_react.default.createElement(_reduxForm.Field, {
    name: "address_state",
    label: t("State/Region"),
    component: renderEmailField,
    t: t
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(zipClassName)
  }, /*#__PURE__*/_react.default.createElement(_reduxForm.Field, {
    name: "address_zip",
    label: t("ZIP/Postal"),
    component: renderEmailField,
    t: t
  })), mode === "billing" && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(classes.marginB12, classes.input50per)
  }, /*#__PURE__*/_react.default.createElement(_reduxForm.Field, {
    type: "numeric",
    count: true,
    helperTextNoWrap: true,
    name: "cameraNum",
    label: t("Cameras"),
    component: renderEmailField,
    value: camCnt,
    PlusButtonDis: camCnt === _pittaModules.MAX_CAM_COUNT,
    MinusButtonDis: camCnt === 1,
    onPlus: function onPlus() {
      dispatch((0, _reduxForm.change)("BillInfoForm", "cameraNum", camCnt + 1));
      setCamCnt(function (c) {
        return Math.min(c + 1, _pittaModules.MAX_CAM_COUNT);
      });
      setDisabledChange(false);
    },
    onMinus: function onMinus() {
      console.log("minus", camCnt);
      dispatch((0, _reduxForm.change)("BillInfoForm", "cameraNum", camCnt - 1));
      setCamCnt(function (c) {
        return Math.max(c - 1, 1);
      });
      setDisabledChange(false);
    },
    onChange: handleCamNumInput,
    t: t,
    helperText: t("available on your_", {
      a: _pittaModules.MAX_CAM_COUNT
    })
  })), mode === "billing" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(referralChecked && classes.referralDiv)
  }, /*#__PURE__*/_react.default.createElement(_reduxForm.Field, {
    name: "ReferralCheck",
    value: "ReferralCheck",
    checked: referralChecked,
    onChange: handleReferralInput,
    label: /*#__PURE__*/_react.default.createElement(_2.Typography, {
      category: "Default",
      variant: "Body"
    }, t("Referral code")),
    component: renderCheckField,
    t: t
  })), referralChecked && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.input50per
  }, /*#__PURE__*/_react.default.createElement(_reduxForm.Field, {
    name: "referralCode",
    component: renderEmailField,
    t: t
  }))), mode !== "change" && /*#__PURE__*/_react.default.createElement(_2.Button, {
    fullWidth: true,
    color: "primary",
    type: "submit",
    loading: loading,
    startIcon: freetrial ? "" : /*#__PURE__*/_react.default.createElement(_Lock.default, null),
    className: (0, _clsx2.default)(classes.marginT3, !referralChecked && classes.closeInput, btnClassName)
  }, freetrial ? t("subscribe") : t("Try 1 month free"))));
};
var BillingForm = (0, _reduxForm.reduxForm)({
  form: "BillInfoForm",
  touchOnBlur: false
})(BillInfo);
var _default = BillingForm;
exports.default = _default;